import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Label } from "reactstrap";
import CustomReactSelect from "../../components/CustomReactSelect";
import ButtonLoader from "../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../ticketModule/variables/ListingVariables";

const SelectCriteria = (props) => {
	return (
		<Container fluid className="p-0">
			<Form>
				<Label className="select-criteria-form-title">
					Select Criteria
				</Label>
				<Row className="row-one">
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-5">
								Employee
							</Form.Label>
							<CustomReactSelect
								options={props.EmpList}
								onChange={(obj) =>
									props.getEmpTimesheetStatus(obj)
								}
								className="dropDown"
								placeholder="Select"
								value={props.formFields?.empID}
							/>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-5">Year</Form.Label>
							<CustomReactSelect
								options={props.joiningYear}
								onChange={(obj) => props.getYearStatus(obj)}
								className="dropDown"
								placeholder="Select"
								value={props.formFields?.selectedYear}
							/>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-5">
								Status
							</Form.Label>
							<CustomReactSelect
								options={props.status}
								onChange={(obj) => props.handleStatus(obj)}
								className="dropDown"
								placeholder="Select"
								value={props.formFields?.status}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="row-two">
					<Col lg={12}>
						<Row>
							<Col lg={4}>
								<Form.Group className="d-flex align-items-center m-0">
									<Form.Label className="mb-0 sup-Label">
										Supervisor
									</Form.Label>
									<CustomReactSelect
										className="dropDown supervisorNameDropDown"
										value={props.selectedSupervisor}
										options={props.supervisorList}
										isSearchable={false}
										isDisabled={
											props.disableSupervisorDropdown
										}
										onChange={(obj) =>
											props.handleSupervisorListChange(
												obj
											)
										}
									/>
								</Form.Group>
							</Col>
							<Col lg={4}>
								<Form.Group className="d-flex align-items-center m-0">
									<Form.Label className="mb-0 month-label">
										Month
									</Form.Label>
									<CustomReactSelect
										options={props.byMonth}
										onChange={props.handleChange}
										className="dropDown"
										placeholder="Select Month"
										value={props.formFields?.selectMonth}
									/>
								</Form.Group>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row className="criteria-form-btns">
					<Col className="align-items-center d-flex btns-col">
						<input
							type="submit"
							value="Submit"
							className="submit-btn leftBtn"
							onClick={props.getEmpTimeSheet}
						/>
						<ButtonLoader
							className={ExcelBtnClassName}
							onClick={props.exportToExcel}
							disabled={
								!props.recordFound || props.showBtnLoading
							}
							btnTitle={ExcelBtnTitle}
							showBtnLoading={props.showBtnLoading}
						/>
					</Col>
				</Row>
				<div className="clear"></div>
			</Form>
		</Container>
	);
};

export default SelectCriteria;
